import { render, staticRenderFns } from "./giving.vue?vue&type=template&id=0834798c&scoped=true&"
import script from "./giving.vue?vue&type=script&lang=js&"
export * from "./giving.vue?vue&type=script&lang=js&"
import style0 from "./giving.vue?vue&type=style&index=0&id=0834798c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0834798c",
  null
  
)

export default component.exports